// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2oOE2","footer":"ChangeClinic_footer__M6mx7"};